module.exports = __webpack_public_path__ + "assets/img/cf80c74e8bea1c074651a5dea1d4ead2.svg";